/**
 * React Timetable Context (Full dnd-kit Conversion)
 * Provides timetable state to all components
 */
import { createContext } from 'react';

const ReactTimetableContext = createContext({
    courseBoxes: [],
    tbaBoxes: [],
    virtualBoxes: [],
    allRegularBoxes: [],
    gridBounds: { startMinutes: 540, endMinutes: 1380 },
    showVirtualCourses: () => { },
    hideVirtualCourses: () => { },
    addSection: () => { },
    removeSection: () => { },
    swapSection: () => { },
});

export default ReactTimetableContext;
